

































import { Component } from 'vue-property-decorator'
import BaseSearchPage from '../../../../base/pages/suche/page/_page.vue'
import SearchForm from '~components/content/widgets/SearchForm.vue'
import { ListingPageVariables } from '~base/mixins/listings'
import { ApolloOperationVariables } from '~base/common/types'
import SearchLayout from '~components/content/layouts/SearchLayout.vue'

@Component<BaseSearchPage & SearchPage>({
  components: {
    SearchForm,
  },

  apollo: {
    search: {
      skip() {
        return !this.$route.query.s
      },
      query: require('~base/graphql/queries/SearchPosts.gql'),
      variables(): ListingPageVariables {
        return this.variables
      },
      prefetch({ route }: any): ApolloOperationVariables | boolean {
        if (route.query.s) {
          return {
            first: this.perPage,
            page: parseInt(route.params.page || 2),
            query: route.query.s,
            order: this.sortorder,
          }
        }
        return false
      },
      result({ data }) {
        this.gotResult(data)
      },
    },
  },
})
export default class SearchPage extends BaseSearchPage {
  get title(): string {
    const searchTitle = this.$t('seo.title.search').toString()
    if (this.$route.query.s) {
      return `„${this.$route.query.s}“ - ${searchTitle}`
    }
    return searchTitle
  }

  get layouts() {
    return [{ component: SearchLayout, items: 5 }]
  }
}
